import axios, { AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";
import { clearSessionAndRedirect, hadValidSession } from "../utils/auth";

// NOTE: This is the API URL prefix for dev
// For production, backend proxy expects calls to /api
// So we need to prefix with the backend URL for local dev
// but just use /api in production (handled by backend proxy)
const BACKEND_URL = import.meta.env.VITE_URL_PREFIX || "";

export const axiosClient = axios.create({
  withCredentials: true,
  baseURL: BACKEND_URL,
});

// Intercepteur de réponse pour gérer les erreurs 403
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si on reçoit une erreur 403 (Forbidden) et que l'utilisateur avait un token
    if (error.response?.status === 403 && hadValidSession()) {
      console.warn(
        "Session expirée ou non autorisée. Redirection vers la page d'accueil."
      );
      clearSessionAndRedirect();
    }

    return Promise.reject(error);
  }
);

export const customInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
  const source = axios.CancelToken.source();
  const token = Cookies.get("token");
  const headers = {
    ...config.headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    // Disable cache in development to avoid 304 issues with Vite
    ...(import.meta.env.DEV ? { "Cache-Control": "no-cache" } : {}),
  };

  const promise = axiosClient({
    ...config,
    headers,
    cancelToken: source.token,
  }).then(({ data }) => data);

  // eslint-disable-next-line
  // @ts-ignore:external-dependencies
  promise.cancel = () => {
    source.cancel("Query was cancelled by React Query");
  };

  return promise;
};
